<div class="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
  <app-reporting-times-entries />
</div>
